module.exports = __webpack_public_path__ + "img/sass.e0f651ac.svg";